module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/82.bb319e98.png";